/* Zeyland Homewear — theme interactions */
(function () {
  'use strict';

  /* ---------- Carousel arrows + progress ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var bar = root.querySelector('[data-carousel-bar]');

    function step() {
      var item = track.querySelector(':scope > *');
      if (!item) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap || 16);
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 4);
      if (next) next.toggleAttribute('disabled', track.scrollLeft >= max - 4);
      if (bar && max > 0) {
        var ratio = track.clientWidth / track.scrollWidth;
        var pos = track.scrollLeft / max;
        bar.style.width = Math.max(ratio * 100, 12) + '%';
        bar.style.transform = 'translateX(' + pos * (100 / Math.max(ratio, 0.12) - 100) + '%)';
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Tabs (generic) ---------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        var scope = root.closest('[data-tab-scope]') || root.parentElement;
        scope.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-tab-panel') !== tab.getAttribute('data-tab-target');
        });
      });
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initSlideshow(root) {
    var slides = root.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;
    var current = 0;
    var counter = root.querySelector('[data-slide-counter]');
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var timer;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === current);
      });
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
    }

    function schedule() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1); }, 6000);
    }

    root.querySelectorAll('[data-slide-prev]').forEach(function (b) {
      b.addEventListener('click', function () { show(current - 1); schedule(); });
    });
    root.querySelectorAll('[data-slide-next]').forEach(function (b) {
      b.addEventListener('click', function () { show(current + 1); schedule(); });
    });

    show(0);
    schedule();
  }

  /* ---------- Outfit words (hover/tap to switch panel) ---------- */
  function initOutfit(root) {
    var words = root.querySelectorAll('[data-outfit-word]');
    var panels = root.querySelectorAll('[data-outfit-panel]');
    function activate(key) {
      words.forEach(function (w) {
        w.classList.toggle('is-active', w.getAttribute('data-outfit-word') === key);
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-outfit-panel') === key);
      });
    }
    words.forEach(function (w) {
      var key = w.getAttribute('data-outfit-word');
      w.addEventListener('mouseenter', function () { activate(key); });
      w.addEventListener('click', function () { activate(key); });
      w.addEventListener('focus', function () { activate(key); });
    });
  }

  /* ---------- Hotspots ---------- */
  function initHotspots(root) {
    var spots = root.querySelectorAll('[data-hotspot]');
    spots.forEach(function (spot) {
      var toggle = spot.querySelector('[data-hotspot-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = spot.classList.contains('is-open');
        spots.forEach(function (s) { s.classList.remove('is-open'); });
        if (!open) spot.classList.add('is-open');
      });
    });
    document.addEventListener('click', function () {
      spots.forEach(function (s) { s.classList.remove('is-open'); });
    });
  }

  /* ---------- Dialog openers ---------- */
  function initDialogs(scope) {
    scope.querySelectorAll('[data-dialog-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dlg = document.getElementById(btn.getAttribute('data-dialog-open'));
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      });
    });
    scope.querySelectorAll('dialog [data-dialog-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { btn.closest('dialog').close(); });
    });
    scope.querySelectorAll('dialog').forEach(function (dlg) {
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });
    });
  }

  /* ---------- Add multiple items to cart (bundle) ---------- */
  function initBundles(scope) {
    scope.querySelectorAll('select[data-bundle-variant]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var card = sel.closest('.bundle__product');
        if (!card) return;
        var opt = sel.options[sel.selectedIndex];
        var priceEl = card.querySelector('[data-bundle-price]');
        if (priceEl) {
          var price = opt.getAttribute('data-price') || '';
          var compare = opt.getAttribute('data-compare');
          /* Not: <option>'da yüzde verisi yok; paket seçicide yüzde rozeti kart üstünde durur */
          priceEl.innerHTML = compare
            ? '<span class="price--sale">' + price + '</span> <s>' + compare + '</s>'
            : '<span>' + price + '</span>';
        }
        var img = opt.getAttribute('data-img');
        var imgEl = card.querySelector('.bundle__product-media img');
        if (img && imgEl) { imgEl.srcset = ''; imgEl.src = img; }
      });
    });
    scope.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var container = btn.closest('[data-bundle]') || document;
        var ids = [];
        var selects = container.querySelectorAll('[data-bundle-variant]');
        if (selects.length) {
          selects.forEach(function (s) { if (s.value) ids.push(s.value); });
        } else {
          ids = (btn.getAttribute('data-bundle-add') || '').split(',').filter(Boolean);
        }
        if (!ids.length) return;
        btn.setAttribute('aria-busy', 'true');
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart'; })
          .finally(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  }

  /* ---------- Floating header: docks to top + sides on scroll ---------- */
  function initStickyHeader() {
    var header = document.querySelector('[data-floating-header]');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('is-docked', window.scrollY > 20);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    scope.querySelectorAll('[data-outfit]').forEach(initOutfit);
    scope.querySelectorAll('[data-hotspots]').forEach(initHotspots);
    initDialogs(scope);
    initBundles(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initStickyHeader();
  });

  /* Re-init inside theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  /* Ürün kartı renk swatch'ı: PDP'ye YÖNLENDİRME YOK — kart o renge döner
     (görsel + renk adı + fiyat + kartın tüm linkleri/hızlı bakış hedefi). */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('.swatch') : null;
    if (!sw) return;
    var card = sw.closest('[data-product-card]');
    if (!card) return;
    // Eski sürümden kalan link swatch'lar da yönlendirmesin
    if (sw.tagName === 'A') { e.preventDefault(); }

    var src = sw.getAttribute('data-swatch-img');
    var img = card.querySelector('.product-card__img');
    if (img && src) {
      // srcset ÖNCE kaldırılmazsa tarayıcı eski srcset görselini gösterir → anında değişmez
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
      var alt = sw.getAttribute('data-swatch-alt');
      if (alt) { img.alt = alt; }
      // Hover (2. foto) görselini gizle: seçilen renk üstte kalsın, eski renk hover'da çıkmasın
      var hoverImg = card.querySelector('.product-card__img--hover');
      if (hoverImg) { hoverImg.style.display = 'none'; }
    }

    var color = sw.getAttribute('data-swatch-color');
    var colorEl = card.querySelector('.product-card__color');
    if (colorEl && color) { colorEl.textContent = color; }

    var price = sw.getAttribute('data-swatch-price');
    var priceEl = card.querySelector('.product-card__price');
    if (priceEl && price) {
      var compare = sw.getAttribute('data-swatch-compare');
      var pct = sw.getAttribute('data-swatch-pct');
      var priceSpan = document.createElement('span');
      priceSpan.textContent = price;
      if (compare) { priceSpan.className = 'price--sale'; }
      priceEl.textContent = '';
      priceEl.appendChild(priceSpan);
      if (compare) {
        var oldPrice = document.createElement('s');
        oldPrice.textContent = compare;
        priceEl.appendChild(oldPrice);
        /* Yüzde sunucuda hesaplandı (zey-pct); JS para birimi metninden hesaplamaz */
        if (pct) {
          var pctEl = document.createElement('span');
          pctEl.className = 'price__pct';
          pctEl.textContent = '%' + pct;
          priceEl.appendChild(pctEl);
        }
      }
    }

    // Kart linkleri seçilen renge gitsin (yoksa görsel A rengi, link B rengi olurdu)
    var url = sw.getAttribute('data-swatch-url');
    if (url) {
      card.querySelectorAll('.product-card__imglink, .product-card__title').forEach(function (a) {
        a.setAttribute('href', url);
      });
      var rating = card.querySelector('.product-card__rating');
      if (rating) { rating.setAttribute('href', url + '#yorumlar'); }
      card.querySelectorAll('[data-quick-view-url]').forEach(function (el) {
        el.setAttribute('data-quick-view-url', url);
      });
    }

    var all = card.querySelectorAll('.swatch');
    for (var i = 0; i < all.length; i++) {
      all[i].classList.remove('is-active');
      if (all[i].hasAttribute('aria-pressed')) { all[i].setAttribute('aria-pressed', 'false'); }
    }
    sw.classList.add('is-active');
    if (sw.hasAttribute('aria-pressed')) { sw.setAttribute('aria-pressed', 'true'); }
  });

  /* Performans: kart görünür olunca varyant görsellerini önceden yükle → tıklamada anında değişir (touch dahil) */
  function preloadSwatchImages(wrap) {
    if (!wrap || wrap.dataset.preloaded) return;
    wrap.dataset.preloaded = '1';
    var sws = wrap.querySelectorAll('.swatch[data-swatch-img]');
    for (var i = 0; i < sws.length; i++) {
      var pre = new Image();
      pre.src = sws[i].getAttribute('data-swatch-img');
    }
  }
  if ('IntersectionObserver' in window) {
    var swIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { preloadSwatchImages(en.target); swIO.unobserve(en.target); }
      });
    }, { rootMargin: '300px' });
    var observeSwatches = function (scope) {
      (scope || document).querySelectorAll('.product-card__swatches').forEach(function (w) { swIO.observe(w); });
    };
    document.addEventListener('DOMContentLoaded', function () { observeSwatches(document); });
    observeSwatches(document);
    document.addEventListener('shopify:section:load', function (e) { observeSwatches(e.target); });
  } else {
    document.addEventListener('pointerover', function (e) {
      var wrap = e.target.closest ? e.target.closest('.product-card__swatches') : null;
      preloadSwatchImages(wrap);
    }, { passive: true });
  }
})();

/* ===== AJAX sepete ekleme + sepete ucan gorsel animasyonu ===== */
(function () {
  'use strict';
  var busy = false;

  function cartIcon() { return document.querySelector('.site-header__cart'); }

  function updateBadge(count) {
    var icon = cartIcon();
    if (!icon) return;
    var badge = icon.querySelector('.site-header__cart-count');
    if (!badge && count > 0) {
      badge = document.createElement('span');
      badge.className = 'site-header__cart-count';
      icon.appendChild(badge);
    }
    if (!badge) return;
    badge.textContent = count;
    if (badge.animate) {
      badge.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.55)' }, { transform: 'scale(1)' }],
        { duration: 480, easing: 'cubic-bezier(0.3, 1.4, 0.5, 1)' }
      );
    }
  }

  function fly(sourceImg) {
    var icon = cartIcon();
    if (!icon || !sourceImg || !sourceImg.getBoundingClientRect) return;
    var s = sourceImg.getBoundingClientRect();
    var t = icon.getBoundingClientRect();
    if (!s.width || !t.width) return;
    var clone = document.createElement('img');
    clone.src = sourceImg.currentSrc || sourceImg.src;
    clone.alt = '';
    clone.style.cssText =
      'position:fixed;z-index:500;left:' + s.left + 'px;top:' + s.top + 'px;' +
      'width:' + s.width + 'px;height:' + s.height + 'px;object-fit:cover;' +
      'border-radius:14px;pointer-events:none;margin:0;will-change:transform,opacity;';
    document.body.appendChild(clone);
    var dx = (t.left + t.width / 2) - (s.left + s.width / 2);
    var dy = (t.top + t.height / 2) - (s.top + s.height / 2);
    if (!clone.animate) { clone.remove(); return; }
    var anim = clone.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 70) + 'px) scale(0.35)', opacity: 0.9, offset: 0.6 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.06)', opacity: 0.35 }
      ],
      { duration: 750, easing: 'cubic-bezier(0.5, -0.05, 0.3, 1)' }
    );
    anim.onfinish = function () { clone.remove(); };
    anim.oncancel = function () { clone.remove(); };
  }

  function feedback(btn) {
    if (!btn || btn.dataset.zeyFeedback === '1') return;
    btn.dataset.zeyFeedback = '1';
    var orig = btn.textContent;
    btn.textContent = 'Sepete Eklendi ✓';
    setTimeout(function () {
      btn.textContent = orig;
      delete btn.dataset.zeyFeedback;
    }, 1400);
  }

  window.zeyAddToCart = function (id, qty, opts) {
    opts = opts || {};
    if (busy || !id) return Promise.resolve();
    busy = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        busy = false;
        fly(opts.image);
        updateBadge(cart.item_count);
        feedback(opts.button);
        document.dispatchEvent(new CustomEvent('zey:cart:added', { detail: cart }));
      })
      .catch(function () {
        busy = false;
        /* AJAX basarisizsa dogal form gonderimine geri don */
        if (opts.fallbackForm) {
          opts.fallbackForm.setAttribute('data-zey-native', '1');
          opts.fallbackForm.submit();
        }
      });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-zey-native')) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    e.preventDefault();
    var qtyInput = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');
    var scope = form.closest('.pdp') || form.closest('[data-qv-drawer]') || form.closest('.shopify-section') || document;
    var img =
      scope.querySelector('.pdp__media.is-active img') ||
      scope.querySelector('.qv__media img') ||
      scope.querySelector('img');
    window.zeyAddToCart(
      parseInt(idInput.value, 10),
      parseInt(qtyInput && qtyInput.value, 10) || 1,
      { image: img, button: btn, fallbackForm: form }
    );
  }, true);
})();
